let isDebug = process.env.NODE_ENV === 'development';

export function initDebugLog(newDebug = false) {
  isDebug = newDebug;
}

export function debugLog(text: any) {
  if (!isDebug) return;
  console.log(text);
}
